import { atomFamily, selectorFamily } from "recoil"
import { notificationSettingsSelector } from "src/recoil/selectors/settings/notificationSettingsSelector"

export const isNewContactPushEnabledStateFamily = atomFamily<boolean | undefined, string>({
  key: "atoms/settings/notifications/isNewContactPushEnabledState",
  default: selectorFamily<boolean | undefined, string>({
    key: "atoms/settings/notifications/isNewContactPushEnabledState_default",
    get:
      (organizationId) =>
      ({ get }) => {
        const settings = get(notificationSettingsSelector)
        if (settings == null) {
          return
        }
        const settingSelect = settings.find((e) => e.teamId === organizationId)
        return settingSelect?.mailReceivedNotice.push
      },
  }),
})
